import hdrm from '../../hdrm';

export default (...args) => hdrm.accessors.getLiveElementByCoords(...args);
